import { useParams } from '@tanstack/react-router'
import { SopReader } from '@/shell/services/sop-registry'

/** /sop-library/$sopId — one SOP as a full page (read-only). */
export function SopLibraryReaderPage() {
  const { sopId } = useParams({ strict: false }) as { sopId?: string }
  if (!sopId) return null
  return <SopReader key={sopId} sopId={sopId} backTo="/sop-library" backLabel="SOP Library" />
}
